import { render, staticRenderFns } from "./mutualHelpList.vue?vue&type=template&id=520d323a&"
import script from "./mutualHelpList.vue?vue&type=script&lang=js&"
export * from "./mutualHelpList.vue?vue&type=script&lang=js&"
import style0 from "./mutualHelpList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports